<template>
  <div class="container">
    <div class="row">
      <div class="form-group col-md-4">
        <label class="control-label">
          Declaración de posible conflicto de interés
        </label>
        <p-radio
          class="d-inline-block"
          v-model="bandera"
          label="1"
        >Si</p-radio>
        <p-radio
          class="d-inline-block"
          v-model="bandera"
          label="0"
        >No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <div class="row">
          <legend>Posibles conflictos de intereses por participaciones económicas o financieras del declarante, cónyuge, concubina, concubinario y/o
            dependientes económicos.</legend>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label class="control-label">Tipo de Operación</label>
            <el-select
              filterable
              class="select-default"
              placeholder="Seleccione una opción"
              name="tipo_operacion_id"
              v-validate="membresiasValidations.tipo_operacion_id"
              v-model="item_membresias.tipo_operacion_id"
            >
              <el-option
                v-for="option in operaciones"
                class="select-default"
                :value="option.id"
                :label="option.valor"
                :key="option.label"
              ></el-option>
            </el-select><small
              class="text-danger"
              v-show="tipo_operacion_id.invalid"
            >
              {{ getError('tipo_operacion_id') }}
            </small>
          </div>

          <div class="form-group col-md-6">
            <label class="control-label">Nombre de la empresa, sociedad o persona física</label>
            <input
              class="form-control"
              type="text"
              name="nombre_institucion"
              v-validate="membresiasValidations.nombre_institucion"
              v-model="item_membresias.nombre_institucion"
              placeholder="Nombre de la institución"
            > <small
              class="text-danger"
              v-show="nombre_institucion.invalid"
            >
              {{ getError('nombre_institucion') }}
            </small>
          </div>

          <div class="form-group col-md-6">
            <label class="control-label">Inscripcion en el registro público u otro dato que permita su identificación (En su caso)</label>
            <input
              class="form-control"
              type="text"
              name="registro_publico"
              v-validate="membresiasValidations.registro_publico"
              v-model="item_membresias.registro_publico"
              placeholder="Inscripción en el registro público"
            > <small
              class="text-danger"
              v-show="registro_publico.invalid"
            >
              {{ getError('registro_publico') }}
            </small>
          </div>

          <div class="form-group col-md-6">
            <label class="control-label">Tipo de Sociedad en la que se participa o con la que se contrata (en su caso)</label>
            <el-select
              filterable
              class="select-default"
              placeholder="Seleccione una opción"
              name="tipo_sociedad_id"
              v-validate="membresiasValidations.tipo_sociedad_id"
              v-model="item_membresias.tipo_sociedad_id"
            >
              <el-option
                v-for="option in sociedades"
                class="select-default"
                :value="option.id"
                :label="option.valor"
                :key="option.label"
              ></el-option>
            </el-select><small
              class="text-danger"
              v-show="tipo_sociedad_id.invalid"
            >
              {{ getError('tipo_sociedad_id') }}
            </small>
          </div>
          <div
            class="form-group col-md-6"
            v-if=" item_membresias.tipo_sociedad_id == 4"
          >
            <label class="control-label">Especifique</label>
            <input
              class="form-control"
              type="text"
              name="tipo_sociedad_especificar"
              v-validate="membresiasValidations.tipo_sociedad_especificar"
              v-model="item_membresias.tipo_sociedad_especificar"
              placeholder="Especificar"
            ><small
              class="text-danger"
              v-show="tipo_sociedad_especificar.invalid"
            >
              {{ getError('tipo_sociedad_especificar') }}
            </small>
          </div>
          <div class="form-group col-md-6">
            <label class="control-label">Antigüedad en la participación o convenio (Años)</label>
            <input
              class="form-control"
              type="number"
              name="antiguedad"
              v-validate="membresiasValidations.antiguedad"
              v-model="item_membresias.antiguedad"
              placeholder="Inscripción en el registro público"
            > <small
              class="text-danger"
              v-show="antiguedad.invalid"
            >
              {{ getError('antiguedad') }}
            </small>
          </div>
          <div class="form-group col-md-6">
            <label class="control-label">Responsable del posible conflicto de interés</label>
            <el-select
              filterable
              class="select-default"
              placeholder="Seleccione una opción"
              name="tipo_responsable_id"
              v-validate="membresiasValidations.tipo_responsable_id"
              v-model="item_membresias.tipo_responsable_id"
            >
              <el-option
                v-for="option in responsables"
                class="select-default"
                :value="option.id"
                :label="option.valor"
                :key="option.label"
              ></el-option>
            </el-select><small
              class="text-danger"
              v-show="tipo_responsable_id.invalid"
            >
              {{ getError('tipo_responsable_id') }}
            </small>
          </div>

          <div class="form-group col-md-4">
            <label class="control-label">Fecha de constitución de la sociedad</label>
            <div class="form-group">
              <el-date-picker
                type="date"
                name="fecha_inicio"
                v-validate="membresiasValidations.fecha_inicio"
                v-model="item_membresias.fecha_inicio"
                value-format="dd-MM-yyyy"
                format="dd-MM-yyyy"
                placeholder="Seleccione fecha"
              >
              </el-date-picker>

              <small
                class="text-danger"
                v-show="fecha_inicio.invalid"
              >
                {{ getError('fecha_inicio') }}
              </small>
            </div>
          </div>

          <div class="form-group col-md-4">
            <label class="control-label">Sector / Industria </label>
            <el-select
              class="select-default"
              placeholder="Seleccione una opción"
              filterable
              name="sector_industria_id"
              v-validate="membresiasValidations.sector_industria_id"
              v-model="item_membresias.sector_industria_id"
            >
              <el-option
                v-for="option in sectores"
                class="select-default"
                :value="option.id"
                :label="option.valor"
                :key="option.label"
              ></el-option>
            </el-select>
            <small
              class="text-danger"
              v-show="sector_industria_id.invalid"
            >
              {{ getError('sector_industria_id') }}
            </small>
          </div>
          <div
            class="form-group col-md-6"
            v-if=" item_membresias.sector_industria_id == 11"
          >
            <label class="control-label">Especificar sector industria</label>
            <input
              class="form-control"
              type="text"
              name="especificar_sector_industria"
              v-validate="membresiasValidations.especificar_sector_industria"
              v-model="item_membresias.especificar_sector_industria"
              placeholder="Especificar"
            >
          </div>
          <div class="form-group col-md-4">
            <label class="control-label">Tipo de participación o contrato</label>
            <input
              class="form-control"
              type="text"
              name="tipo_participacion"
              v-validate="membresiasValidations.tipo_participacion"
              v-model="item_membresias.tipo_participacion"
              placeholder="Inscripción en el registro público"
            > <small
              class="text-danger"
              v-show="tipo_participacion.invalid"
            >
              {{ getError('tipo_participacion') }}
            </small>
          </div>
          <div class="form-group col-md-4">
            <label class="control-label">
              Inicio de participación o contrato:
            </label>
            <br>
            <div>
              <p-radio
                name="participacion"
                v-validate="membresiasValidations.participacion"
                v-model="item_membresias.participacion"
                :inline=true
                label="1"
              >Antes del servicio público</p-radio>
              <p-radio
                name="participacion"
                v-validate="membresiasValidations.participacion"
                v-model="item_membresias.participacion"
                :inline=true
                label="2"
              >Después del servicio público</p-radio>
            </div>
            <small
              class="text-danger"
              v-show="participacion.invalid"
            >
              {{ getError('participacion') }}
            </small>

          </div>
          <div class="form-group col-md-12">
            <label class="control-label">Observaciones / Comentarios</label>
            <input
              class="form-control"
              type="text"
              v-model="item_membresias.observaciones"
              placeholder="Observaciones / Comentarios"
            >
          </div>

        </div>
        <domicilio
          titulo="de la institución"
          v-model="n_domicilio"
        ></domicilio>

        <div class="row justify-content-end m-3">
          <button
            class="btn btn-success"
            @click.prevent="addItem()"
          >
            <span v-if="edit_item == null">
              <i class="fa fa-plus"></i> Guardar
            </span>

            <span v-else>
              <i class="fa fa-save"></i> Guardar
            </span>
          </button>
          <button
            class="btn btn-danger ml-3"
            @click.prevent="cancelEdit()"
          >
            <span>
              <i class="fa fa-times"></i> Cancelar
            </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>

      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button
            class="btn btn-primary"
            @click.prevent="showItem()"
          >
            <span>
              <i class="fa fa-plus"></i> Agregar
            </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">

          <div class="col-sm-12 col-md-12 col-lg-12">
            <b-table
              id="tbl_metales"
              responsive
              hover
              :items="list_membresias"
              :fields="fields_list"
              show-empty
            >
              <!-- :fields="fields_list" -->
              <template
                slot="acciones"
                slot-scope="row"
                class="actions"
              >
                <b-button
                  size="sm"
                  @click.prevent="editItem(row)"
                  class="edit mr-2"
                  :disabled="edit_item != null"
                >
                  Editar <i class="fas fa-pencil-alt ml-2"></i>
                </b-button>
                <b-button
                  size="sm"
                  @click.prevent="removeItem(row.index)"
                  class="delete mr-2"
                  :disabled="edit_item != null"
                >
                  Eliminar <i class="fas fa-trash-alt ml-2"></i>
                </b-button>
              </template>
              <template slot="empty">
                <h5>No existen registros</h5>
              </template>
              <template
                slot="domicilio_entidad_federativa_id"
                slot-scope="row"
              >
                {{getEntidad(row.item.domicilio_entidad_federativa_id)}}</template>
              <template
                slot="domicilio_localidad_id"
                slot-scope="row"
              >
                {{getLocalidad(row.item.domicilio_localidad_id)}}
              </template>
              <template
                slot="domicilio_municipio_id"
                slot-scope="row"
              >{{getMunicipio(row.item.domicilio_municipio_id)}}</template>
              <template
                slot="domicilio_pais_id"
                slot-scope="row"
              >{{getPais(row.item.domicilio_pais_id)}}</template>
              <template
                slot="pais_registro_id"
                slot-scope="row"
              >{{getPais(row.item.pais_registro_id)}}</template>
              <template
                slot="sector_industria_id"
                slot-scope="row"
              >{{getSector(row.item.sector_industria_id)}}</template>
              <template
                slot="tipo_operacion_id"
                slot-scope="row"
              >{{getOperacion(row.item.tipo_operacion_id)}}</template>
              <template
                slot="tipo_sociedad_id"
                slot-scope="row"
              >{{getSociedad(row.item.tipo_sociedad_id)}}</template>
              <template
                slot="tipo_responsable_id"
                slot-scope="row"
              >{{getResponsables(row.item.tipo_responsable_id)}}
              </template>
              <template
                slot="participacion"
                slot-scope="row"
              >{{getParticipacion(row.item.participacion)}}</template>
              <template
                slot="fecha_inicio"
                slot-scope="row"
              >{{row.item.fecha_inicio}}</template>

            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tag, Select, DatePicker, InputNumber } from "element-ui";
import Domicilio from "../Domicilio.vue";
import { mapFields } from "vee-validate";
export default {
  components: {
    [Tag.name]: Tag,
    [DatePicker.name]: DatePicker,
    [InputNumber.name]: InputNumber,
    Domicilio
  },
  props: ["data"],
  data() {
    return {
      operaciones: null,
      sociedades: null,
      responsables: null,
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: "0",
      modelValidations: {
        nombre: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      },
      sectores: null,
      n_domicilio: null,
      naturalezas: [],
      instituciones: [],
      pagado: null,
      entidadFed: null,
      municipios: null,
      localidades: null,
      localidad: null,
      paises: null,
      isnum: null,
      /* Lista de metales */
      item_membresias: {},
      list_membresias: [],
      membresiasValidations: {
        tipo_operacion_id: {
          required: true
        },
        nombre_institucion: {
          required: true
        },
        registro_publico: {
          required: true
        },
        tipo_sociedad_id: {
          required: true
        },
        antiguedad: {
          required: true
        },
        tipo_responsable_id: {
          required: true
        },
        sector_industria_id: {
          required: true
        },
        fecha_inicio: {
          required: true
        },

        especificar_tipo_institucion: {
          required: true
        },
        especificar_sector_industria: {
          required: true
        },
        tipo_participacion: {
          required: true
        },
        participacion: {
          required: true
        },
        tipo_sociedad_especificar: {
          required: true
        }
      },
      fields_list: [
        {
          key: "acciones",
          label: "Acciones",
          tdClass: "text-center"
        },
        {
          key: "tipo_operacion_id",
          label: "Tipo de Operación",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "nombre_institucion",
          label: "Nombre de la empresa",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "registro_publico",
          label: "Inscripción en el registro público",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "tipo_sociedad_id",
          label: "Tipo de Sociedad",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "antiguedad",
          label: "Antigüedad en la participación",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "tipo_responsable_id",
          label: "Responsable",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "fecha_inicio",
          label: "Fecha de constitución",
          tdClass: "text-center",
          formatter: "emptyFields"
        },
        {
          key: "sector_industria_id",
          label: "Sector/Industria",
          tdClass: "text-center",
          formatter: "emptyFields"
        },
        {
          key: "especificar_sector_industria",
          label: "Especifique",
          tdClass: "text-center",
          formatter: "emptyFields"
        },
        {
          key: "tipo_participacion",
          label: "Tipo de Participación",
          tdClass: "text-center",
          formatter: "emptyFields"
        },
        {
          key: "participacion",
          label: "Inicio de participación",
          tdClass: "text-center",
          formatter: "emptyFields"
        },
        {
          key: "observaciones",
          label: "Observaciones / Comentarios",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_pais_id",
          label: "Pais",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_entidad_federativa_id",
          label: "Entidad federativa",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_municipio_id",
          label: "Municipio",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_localidad_id",
          label: "Localidad",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_colonia",
          label: "Colonia",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_vialidad_tipo",
          label: "Tipo vialidad",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_vialidad_nombre",
          label: "Nombre vialidad",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_cp",
          label: "CP",
          tdClass: "text-right",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_numext",
          label: "Número Exterior",
          tdClass: "text-right",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_numint",
          label: "Número Interior",
          tdClass: "text-right",
          formatter: "emptyFields"
        }
      ]
    };
  },
  computed: {
    ...mapFields([
      "tipo_operacion_id",
      "nombre_institucion",
      "registro_publico",
      "tipo_sociedad_id",
      "antiguedad",
      "tipo_responsable_id",
      "sector_industria_id",
      "tipo_participacion",
      "fecha_inicio",
      "especificar_tipo_institucion",
      "especificar_sector_industria",
      "participacion",
      "tipo_sociedad_especificar"
    ])
  },
  watch: {
    n_domicilio: {
      handler: function() {
        if (this.n_domicilio) {
          this.item_membresias.domicilio_pais_id = this.n_domicilio.pais_id
            ? this.n_domicilio.pais_id
            : 150;
          this.item_membresias.domicilio_entidad_federativa_id = this
            .n_domicilio.entidadF
            ? this.n_domicilio.entidadF
            : "";
          this.item_membresias.domicilio_municipio_id = this.n_domicilio
            .municipio
            ? this.n_domicilio.municipio
            : "";
          this.item_membresias.domicilio_localidad_id = this.n_domicilio
            .localidad
            ? this.n_domicilio.localidad
            : "";
          this.item_membresias.domicilio_cp = this.n_domicilio.cp
            ? this.n_domicilio.cp
            : "";
          this.item_membresias.domicilio_colonia = this.n_domicilio.colonia
            ? this.n_domicilio.colonia
            : "";
          this.item_membresias.domicilio_vialidad_tipo = this.n_domicilio
            .vialidad
            ? this.n_domicilio.vialidad
            : "";
          this.item_membresias.domicilio_vialidad_nombre = this.n_domicilio
            .vialidad_nombre
            ? this.n_domicilio.vialidad_nombre
            : "";
          this.item_membresias.domicilio_numext = this.n_domicilio.ext
            ? this.n_domicilio.ext
            : "";
          this.item_membresias.domicilio_numint = this.n_domicilio.int
            ? this.n_domicilio.int
            : "";
        }
      },
      deep: true
    },
    list_membresias: {
      handler: function() {
        if (this.list_membresias) {
          this.setLocalidades();
          if (this.list_membresias.length == 0) {
            this.bandera = "0";
          } else {
            this.bandera = "1";
          }
        }
      },
      deep: true
    },
    item_membresias: {
      handler: function() {
        if (this.item_membresias) {
          this.pagado = "" + this.item_membresias.pagado;
        }
      },
      deep: true
    },
    pagado() {
      this.item_membresias.pagado = this.pagado;
    }
  },
  methods: {
    emptyFields(value) {
      if (value) {
        if (typeof value === "string" || value instanceof String) {
          return value.toUpperCase();
        } else {
          return value;
        }
      } else {
        return "-";
      }
    },
    getTipo(index) {
      var resp = " ";
      if (this.instituciones) {
        this.instituciones.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getBool(index) {
      var resp = "No";
      if (index == 1 || index == "1") {
        resp = "Si";
        return resp;
      }
      return resp;
    },
    getParticipacion(index) {
      var resp = "No";
      if (index == 1) {
        resp = "Antes del servicio público";
        return resp;
      } else {
        resp = "Después del servicio público";
        return resp;
      }
      return resp;
    },
    getNaturaleza(index) {
      var resp = " ";
      if (this.naturalezas) {
        this.naturalezas.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getSector(index) {
      var resp = " ";
      if (this.sectores) {
        this.sectores.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEntidad(index) {
      var resp = " ";
      if (this.entidadFed) {
        this.entidadFed.forEach(function(item) {
          if (item.id == index) {
            resp = item.nom_ent;
            return resp;
          }
        });
      }
      return resp;
    },
    getLocalidad(index) {
      var resp = "";
      if (this.localidades) {
        this.localidades.forEach(function(item) {
          if (item.id == index) {
            resp = item.nom_loc;
            return resp;
          }
        });
      }
      return resp;
    },
    getMunicipio(index) {
      var resp = "";
      if (this.municipios) {
        this.municipios.forEach(function(item) {
          if (item.id == index) {
            resp = item.nom_mun;
            return resp;
          }
        });
      }
      return resp;
    },
    getPais(index) {
      var resp = "México";
      if (this.paises) {
        this.paises.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getOperacion(index) {
      var resp = " ";
      if (this.operaciones) {
        this.operaciones.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getSociedad(index) {
      var resp = " ";
      if (this.sociedades) {
        this.sociedades.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getResponsables(index) {
      var resp = " ";
      if (this.responsables) {
        this.responsables.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    initItem() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: "",
        municipio: "",
        localidad: "",
        cp: "",
        colonia: "",
        vialidad: "",
        vialidad_nombre: "",
        ext: "",
        int: ""
      };
      this.item_membresias = {
        acciones: "",
        tipo_institucion_id: "",
        nombre_institucion: "",
        naturaleza_membresia_id: "",
        sector_industria_id: "",
        puesto_rol: "",
        fecha_inicio: "",
        pagado: "",
        observaciones: "",
        domicilio_pais_id: 150,
        domicilio_entidad_federativa_id: "",
        domicilio_municipio_id: "",
        domicilio_localidad_id: "",
        domicilio_colonia: "",
        domicilio_cp: "",
        domicilio_numext: "",
        domicilio_numint: "",
        domicilio_vialidad_nombre: "",
        domicilio_vialidad_tipo: ""
      };
    },
    showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem() {
      this.$validator.validateAll().then(response => {
        if (response) {
          if (this.item_membresias) {
            this.item_membresias.ip_id = this.ip_id;
            this.loadButton(this.$refs.btnSave);
            this.$http.post("membresias", this.item_membresias).then(
              response => {
                this.StepOk("Guardado");
                if (this.edit_item === undefined || this.edit_item === null) {
                  this.list_membresias.push({
                    ...response.data.membresia
                  });
                } else {
                  this.list_membresias.splice(
                    this.edit_item.index,
                    1,
                    this.item_membresias
                  );
                  this.edit_item.item._rowVariant = "";
                }
                this.initItem();
                this.showItem();
                this.edit_item = null;
              },
              error => {
                this.StepW(error);
                //this.change =  true;
              }
            );
          }
        } else {
          this.StepW("Hay campos sin completar");
        }
      });
      //console.log(this.item_membresias);
    },
    editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_membresias = {
        ...this.list_membresias[this.edit_item.index]
      };
      this.editDomicilio();
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate(
        {
          scrollTop: 100
        },
        500,
        "swing"
      );
    },
    removeItem(indice) {
      if (this.list_membresias[indice].id !== null) {
        let item = this.list_membresias[indice];
        this.list_membresias.splice(indice, 1);
        this.Ask("Desea borrar este registro", () => {
          this.$http.delete("membresias/" + item.id).then(
            response => {
              /* eventBus.$emit("Empresas", item); */
              this.list_membresias.splice(indice, 1);
            },
            error => {
              this.Err(error);
            }
          );
        });
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    editDomicilio() {
      this.n_domicilio.pais_id = this.item_membresias.domicilio_pais_id
        ? this.item_membresias.domicilio_pais_id
        : 150;
      this.n_domicilio.entidadF = this.item_membresias
        .domicilio_entidad_federativa_id
        ? this.item_membresias.domicilio_entidad_federativa_id
        : "";
      this.n_domicilio.municipio = this.item_membresias.domicilio_municipio_id
        ? this.item_membresias.domicilio_municipio_id
        : "";
      this.n_domicilio.localidad = this.item_membresias.domicilio_localidad_id
        ? this.item_membresias.domicilio_localidad_id
        : "";
      this.n_domicilio.cp = this.item_membresias.domicilio_cp
        ? this.item_membresias.domicilio_cp
        : "";
      this.n_domicilio.colonia = this.item_membresias.domicilio_colonia
        ? this.item_membresias.domicilio_colonia
        : "";
      this.n_domicilio.vialidad = this.item_membresias.domicilio_vialidad_tipo
        ? this.item_membresias.domicilio_vialidad_tipo
        : "";
      this.n_domicilio.vialidad_nombre = this.item_membresias
        .domicilio_vialidad_nombre
        ? this.item_membresias.domicilio_vialidad_nombre
        : "";
      this.n_domicilio.ext = this.item_membresias.domicilio_numext
        ? this.item_membresias.domicilio_numext
        : "";
      this.n_domicilio.int = this.item_membresias.domicilio_numint
        ? this.item_membresias.domicilio_numint
        : "";
    },
    setLocalidades() {
      this.localidades = [];
      if (this.list_membresias) {
        this.list_membresias.forEach(item => {
          if (item.domicilio_localidad_id) {
            this.$http
              .get("localidades/localidad/" + item.domicilio_localidad_id)
              .then(
                response => {
                  this.localidades.push(response.data.localidad);
                },
                error => {
                  this.Err(error);
                }
              );
          }
        });
      }
    },
    validate() {
      return this.$validator.validateAll();
    },
    isNumber(n) {
      //console.log(n);
      n.target.value = n.target.value.replace(/[^\d.-]/g, "");
    }
  },
  created() {
    this.initItem();
    //this.getLocalidades(97250);
    this.$http.get("membresias/" + this.ip_id).then(
      response => {
        this.list_membresias = response.data.membresias;
        this.setLocalidades();
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("cat_institucion").then(
      response => {
        this.instituciones = response.data.institucion;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("cat_naturaleza_membresia").then(
      response => {
        this.naturalezas = response.data.naturalezaMembresia;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("entidadFed").then(
      response => {
        this.entidadFed = response.data.entidadfed;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("paises").then(
      response => {
        this.paises = response.data.pais;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("municipios").then(
      response => {
        this.municipios = response.data.municipios;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("cat_sector_industria").then(
      response => {
        this.sectores = response.data.sectores;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("cat_tipo_operacion_interes").then(
      response => {
        this.operaciones = response.data.tipos;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("cat_tipo_sociedad").then(
      response => {
        this.sociedades = response.data.tipos;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("cat_titular").then(
      response => {
        this.responsables = response.data.titulares;
      },
      error => {
        this.Err(error);
      }
    );
    if (this.data) {
    }
  }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Intereses/Membresias.vue